import { useEffect } from "react";
import { tg } from "../lib/telegram";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

export function Sheet({ open, onClose, title, children, footer }: Props) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.dispatchEvent(new CustomEvent("sheet:open"));
    return () => {
      document.body.style.overflow = prev;
      window.dispatchEvent(new CustomEvent("sheet:close"));
    };
  }, [open]);

  // Telegram BackButton closes the sheet
  useEffect(() => {
    const app = tg();
    if (!app || !open) return;
    const onBack = () => onClose();
    app.BackButton.show();
    app.BackButton.onClick(onBack);
    return () => {
      app.BackButton.offClick(onBack);
      app.BackButton.hide();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <button
        className="fixed inset-0 bg-black/40 sheet-fade-in z-[55]"
        onClick={onClose}
        aria-label="Закрыть"
      />
      <div className="fixed bottom-0 left-0 right-0 bg-surface rounded-t-[var(--radius-2xl)] shadow-[var(--shadow-elevated)] max-h-[90vh] flex flex-col sheet-slide-up z-[60]">
        <div className="flex justify-center pt-3 pb-2 flex-shrink-0">
          <div className="w-10 h-1 bg-ink-200 rounded-full" />
        </div>
        <div className="flex items-center justify-between px-5 pb-3 flex-shrink-0">
          <h2 className="text-[18px] font-bold text-ink-900">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 -mr-1 text-ink-400 hover:text-ink-700 active:scale-90 transition-all"
            aria-label="Закрыть"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="px-5 pt-2 pb-4 flex-1 overflow-y-auto">{children}</div>
        {footer && (
          <div
            className="px-5 py-4 border-t border-ink-100 bg-surface flex-shrink-0"
            style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)" }}
          >
            {footer}
          </div>
        )}
      </div>
    </>
  );
}

function CloseIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}
